import React from "react";
import "../Component/Component.css/AwardsSection.css";
import aw1 from "../Images/aw1.jpg";
import aw2 from "../Images/aw2.jpg";
import aw3 from "../Images/aw3.jpg";
import aw4 from "../Images/aw4.png";
import aw5 from "../Images/aw5.jpg";
import aw6 from "../Images/aw6.jpg";
import aw7 from "../Images/aw7.jpg";
import aw8 from "../Images/aw8.png";


export default function AwardsSection() {
return (
<section className="awards-section">
<div className="content-container">
<h2 className="titleaw">पुरस्कार आणि सम्मान</h2>
<p className="subtitleaw">
समाजसेवा, स्वच्छता, शिक्षण आणि नवोनमेष क्षेत्रातील गौरवक्षण.
</p>


<div className="grid-container">
<img src={aw1} alt="Award" />
<img src={aw2} alt="Award" />
<img src={aw3} alt="Award" />
<img src={aw4} alt="Award" />
<img src={aw5} alt="Award" />
<img src={aw6} alt="Award" />
<img src={aw7} alt="Award" />
<img src={aw8} alt="Award" />
</div>
</div>
</section>
);
}